export default "__VITE_ASSET__BnccRQ2r__"